import * as React from 'react';
import { Text, UnorderedList, ListItem } from '@chakra-ui/react';

import {
  UploadActions,
  UploadButtonSection,
  UploadComplete as UploadCompleteSection,
  Modal,
  AcknowledgeBox,
  RequirementsSummary
} from 'shared-components';

interface IProps {
  sectionTitle: string;
  complete: boolean;
  fileNames: string[];
  onClose: () => void;
  onContinue: () => void;
  onUpload: () => void;
  docKey: string;
  infoOnly: boolean;
  docStatus: string;
  onAcknowledgeToggle: (status: string) => void;
}

const VerificationModal: React.FC<IProps> = (props: IProps) => {
  const { infoOnly, docStatus, docKey, sectionTitle } = props;

  const handleOnClose = () => {
    if (docStatus === 'INFO_ONLY') {
      props.onAcknowledgeToggle('NOT_ACKNOWLEDGED');
    }
    props.onClose();
  };

  const toggleAcknowledge = (key: string, value: boolean) => {
    // prevent call to API if previous call not yet complete
    if ((value === true && docStatus !== 'ACKNOWLEDGED') || (value === false && docStatus === 'ACKNOWLEDGED')) {
      props.onAcknowledgeToggle(value === true ? 'ACKNOWLEDGED' : 'NOT_ACKNOWLEDGED');
    }
  };

  return (
    <Modal id={'verificationBankLetter'} show={true} title={sectionTitle} onClose={handleOnClose} maxWidthPx={1086}>
      {infoOnly ? (
        <>
          <Text>
            During your visa application you may be required to provide a letter from the bank that provides the term
            deposit account in your finance plan.
          </Text>

          <AcknowledgeBox
            id={docKey}
            blurb="Please confirm you have read and understand the above."
            isTicked={docStatus === 'ACKNOWLEDGED'}
            onChange={toggleAcknowledge}
          />

          <UploadActions
            label="Return to document upload"
            complete={docStatus === 'ACKNOWLEDGED'}
            onContinue={handleOnClose}
          />
        </>
      ) : (
        <>
          {props.complete ? (
            <UploadCompleteSection fileNames={props.fileNames} onUpload={props.onUpload} onContinue={props.onClose} />
          ) : (
            <>
              <Text>
                We require a letter from the bank that provides the term deposit account in your finance plan.
              </Text>

              <RequirementsSummary title="Please ask the bank to provide you with a letter that includes the following:">
                <UnorderedList mb={4}>
                  <ListItem>Verification of the full name and account number on the term deposit</ListItem>
                  <ListItem>How long the named person on the account has been a customer of the bank</ListItem>
                </UnorderedList>
              </RequirementsSummary>

              <UploadButtonSection onUpload={props.onUpload}>
                Awaiting upload of <b>Verification Letter from Bank</b>
              </UploadButtonSection>

              <UploadActions complete={props.complete} onContinue={props.onClose} />
            </>
          )}
        </>
      )}
    </Modal>
  );
};

export default VerificationModal;
